import { all, call, put, takeLatest, select } from '@redux-saga/core/effects';

import Types from './cs.types';
import {
  loadingRatesAvrage,
  loadingRatesCount,
  loadingCsPercent,
  loadingHappyCustomers,
  loadingAngryCustomers,
  setRatesAvrage,
  setRatesCount,
  setCsPercent,
  setHappyCustomers,
  setAngryCustomers,
  setPlatformsStatsData,
  setPlatformsStatsLoading,
  setUsersStatsData,
  setUsersStatsLoading,
} from './cs.actinos';
import {
  handleFetchRatesAvrage,
  handleFetchRatesCount,
  handleFetchCustomersByRate,
  handleFetchPlatformsStats,
  handleFetchUsersStats,
} from './cs.helper';
import { handleErrors } from 'utils';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchRatesAvrage({ payload }) {
  const { startDate, endDate } = payload;
  const { locale } = yield select(mapState);

  try {
    // show loading
    yield put(loadingRatesAvrage(true));
    // fetch data
    const res = yield handleFetchRatesAvrage(
      startDate && startDate,
      endDate && endDate
    );

    yield put(setRatesAvrage(res));
  } catch (error) {
    handleErrors(error, locale);
  } finally {
    yield put(loadingRatesAvrage(false));
  }
}

export function* fetchCSPercent({ payload }) {
  const { startDate, endDate } = payload;
  const { locale } = yield select(mapState);

  try {
    // show loading
    yield put(loadingCsPercent(true));
    // fetch data
    const res = yield handleFetchRatesAvrage(
      startDate && startDate,
      endDate && endDate
    );
    yield put(setCsPercent(res));
  } catch (error) {
    handleErrors(error, locale);
  } finally {
    yield put(loadingCsPercent(false));
  }
}

export function* fetchRatesCount({ payload }) {
  const { startDate, endDate } = payload;
  const { locale } = yield select(mapState);

  try {
    // show loading
    yield put(loadingRatesCount(true));
    // fetch data
    const res = yield handleFetchRatesCount(
      startDate && startDate,
      endDate && endDate
    );

    yield put(setRatesCount(res));
  } catch (error) {
    handleErrors(error, locale);
  } finally {
    yield put(loadingRatesCount(false));
  }
}

export function* fetchCustomersByRate({ payload }) {
  const { startDate, endDate, type } = payload;
  const { locale } = yield select(mapState);

  try {
    // show loading by type
    switch (type) {
      // happy customer rate
      case 1:
        yield put(loadingHappyCustomers(true));
        break;
      // angry customer rate
      case 4:
        yield put(loadingAngryCustomers(true));
        break;

      default:
        break;
    }

    // fetch data
    const res = yield handleFetchCustomersByRate(
      startDate && startDate,
      endDate && endDate,
      type && type + ''
    );

    switch (type) {
      // happy customer rate
      case 1:
        yield put(setHappyCustomers(res));
        break;
      // angry customer rate
      case 4:
        yield put(setAngryCustomers(res));
        break;

      default:
        break;
    }
  } catch (error) {
    handleErrors(error, locale);
  } finally {
    switch (type) {
      // happy customer rate
      case 1:
        yield put(loadingHappyCustomers(false));
        break;
      // angry customer rate
      case 4:
        yield put(loadingAngryCustomers(false));
        break;

      default:
        break;
    }
  }
}

function* fetchPlatformsStatsData({ payload }) {
  const { locale } = yield select(mapState);

  try {
    const response = yield handleFetchPlatformsStats(payload);
    yield put(setPlatformsStatsData(response));
  } catch (error) {
    handleErrors(error, locale);
    yield put(setPlatformsStatsLoading(false));
  }
}

function* fetchUsersStats({ payload }) {
  const { locale } = yield select(mapState);

  try {
    const response = yield handleFetchUsersStats(payload);
    yield put(setUsersStatsData(response));
  } catch (error) {
    yield put(setUsersStatsLoading(false));
    handleErrors(error, locale);
  }
}

export function* onFetchRatesAvrage() {
  yield takeLatest(Types.FETCH_RATES_AVRAGE_START, fetchRatesAvrage);
}

export function* onFetchCSPercent() {
  yield takeLatest(Types.FETCH_CS_PERCENT_START, fetchCSPercent);
}

export function* onFetchRatesCount() {
  yield takeLatest(Types.FETCH_RATES_COUNT_START, fetchRatesCount);
}

export function* onFetchHappyCustomers() {
  yield takeLatest(Types.FETCH_HAPPY_CUSTOMERS_START, fetchCustomersByRate);
}

export function* onFetchAngryCustomers() {
  yield takeLatest(Types.FETCH_ANGRY_CUSTOMERS_START, fetchCustomersByRate);
}

function* onFetchPlatformsStats() {
  yield takeLatest(Types.FETCH_PLATFORMS_STATS_DATA, fetchPlatformsStatsData);
}

function* onFetchUsersStats() {
  yield takeLatest(Types.FETCH_USERS_STATS_DATA, fetchUsersStats);
}

export default function* conversationsSagas() {
  yield all([
    call(onFetchRatesAvrage),
    call(onFetchRatesCount),
    call(onFetchCSPercent),
    call(onFetchHappyCustomers),
    call(onFetchAngryCustomers),
    call(onFetchPlatformsStats),
    call(onFetchUsersStats),
  ]);
}
